import { z } from 'zod';

export const inviteeFormValidation = z.object({
  nom: z.string({ required_error: 'Ce champ est Obligatoire' }).min(1, 'Ce champ est obligatoire'),
  prenom: z.string({ required_error: 'Ce champ est Obligatoire' }).min(1, 'Ce champ est obligatoire'),
  mail: z
    .string({ required_error: 'Ce champ est Obligatoire' })
    .min(1, 'Ce champ est obligatoire')
    .email('Ce champ doit être une adresse email valide'),
  fonction: z.string({ required_error: 'Ce champ est Obligatoire' }).min(1, 'Ce champ est obligatoire'),
  organisme: z.string({ required_error: 'Ce champ est Obligatoire' }).min(1, 'Ce champ est obligatoire'),
});
